<template>
  <el-progress
    type="circle"
    v-bind="$attrs"
    :percentage="progresso"
    :width="espessura"
    :stroke-width="linha"
  >
    <span />
  </el-progress>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ElProgress } from "element-plus/es/components/progress/index";

const props = defineProps<{
  percent: string;
  width: string;
  strokeWidth: string;
}>();

const progresso = computed(() => {
  const value = Number(props.percent);
  if (isNaN(value) || value < 0) return 0;
  if (value > 100) return 100;

  return value;
});

const espessura = computed(() => {
  return Number(props.width);
});

const linha = computed(() => {
  return Number(props.strokeWidth);
});
</script>

<style lang="scss" scoped>
@use "element-plus/theme-chalk/el-progress.css";
</style>
